// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValidationErrorColor {
    border-color: red !important;
}

.ValidationSuccessColor {
    border-color: #D5D5D5 !important;
}

.EditNotAllowed{
    cursor: not-allowed !important;
 }


.borderless-table{
    width:100% !important;
    margin-bottom: 5px !important;
}

.borderless-table tr td{
    border-top: none; 
    padding: 5px !important;
}
.cancel-button {
    font-size: 20px; 
    color: #165788; 
    cursor: pointer;
    margin-left: 5px;
}

.borderless-table > tr > td > input, select{
    width: 100% !important;
}

.borderless-table td{
    width: 25% !important;
}

.ui-widget input {
    width: 100% !important;
}

.grid-bg-primary {
    padding: 4px 2px 4px 3px !important;     
    vertical-align: middle;
    text-align: center !important;
}

.grid-button {
    font-size: 20px; 
    color: #165788; 
    cursor: pointer;
}

.grid-button-red {
    font-size: 20px; 
    color: red; 
    cursor: pointer;
    margin-left: 5px;
}

:host ::ng-deep .ui-panel .ui-panel-titlebar {
    display: none;
}

:host ::ng-deep .ui-panel-content-wrapper{
    border-top: 1px solid #D5D5D5 !important;
}

:host ::ng-deep .ui-table .ui-table-tbody > tr > td {
    padding: 4px 2px 4px 3px !important;     
    vertical-align: middle;
}

:host ::ng-deep .ui-table .ui-table-frozen-view .ui-table-tbody > tr > td,
.ui-table .ui-table-unfrozen-view .ui-table-tbody > tr > td {
    height: 30px !important;
}

:host ::ng-deep .ui-table .ui-table-tbody > tr > td {
    height: 30px !important;
}

:host ::ng-deep .ui-table .ui-editable-column input{
    font-size: 13px !important;
}

:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    box-shadow: 3px 3px 12px #165788;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header{
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;    
}
.different.p-dialog .ui-widget .p-dialog-header {
    display:none !important;
 }

 :host ::ng-deep .ui-button.ui-button-icon-only{
    width: 1.7em !important;
    height: 1.7em !important;
 }
 :host ::ng-deep body .ui-inputtext:enabled:focus:not(.ui-state-error) {
    border-color: #ea1212 !important;
    outline: 0 none;
    box-shadow: none; }

:host ::ng-deep select:disabled {   
        box-shadow: none!important;
        color: #858585 !important;
        background-color: #FFF;
        border: 1px solid #D5D5D5;
    }    

`, "",{"version":3,"sources":["webpack://./src/app/commonhelpers/search-panel/search-panel.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;CACjC;;;AAGD;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAG9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,uBAAuB;CAC1B;;CAEA;IACG,uBAAuB;IACvB,wBAAwB;CAC3B;CACA;IACG,gCAAgC;IAChC,eAAe;IAGf,gBAAgB,EAAE;;AAEtB;QACQ,0BAA0B;QAC1B,yBAAyB;QACzB,sBAAsB;QACtB,yBAAyB;IAC7B","sourcesContent":[".ValidationErrorColor {\r\n    border-color: red !important;\r\n}\r\n\r\n.ValidationSuccessColor {\r\n    border-color: #D5D5D5 !important;\r\n}\r\n\r\n.EditNotAllowed{\r\n    cursor: not-allowed !important;\r\n }\r\n\r\n\r\n.borderless-table{\r\n    width:100% !important;\r\n    margin-bottom: 5px !important;\r\n}\r\n\r\n.borderless-table tr td{\r\n    border-top: none; \r\n    padding: 5px !important;\r\n}\r\n.cancel-button {\r\n    font-size: 20px; \r\n    color: #165788; \r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n.borderless-table > tr > td > input, select{\r\n    width: 100% !important;\r\n}\r\n\r\n.borderless-table td{\r\n    width: 25% !important;\r\n}\r\n\r\n.ui-widget input {\r\n    width: 100% !important;\r\n}\r\n\r\n.grid-bg-primary {\r\n    padding: 4px 2px 4px 3px !important;     \r\n    vertical-align: middle;\r\n    text-align: center !important;\r\n}\r\n\r\n.grid-button {\r\n    font-size: 20px; \r\n    color: #165788; \r\n    cursor: pointer;\r\n}\r\n\r\n.grid-button-red {\r\n    font-size: 20px; \r\n    color: red; \r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n:host ::ng-deep .ui-panel .ui-panel-titlebar {\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep .ui-panel-content-wrapper{\r\n    border-top: 1px solid #D5D5D5 !important;\r\n}\r\n\r\n:host ::ng-deep .ui-table .ui-table-tbody > tr > td {\r\n    padding: 4px 2px 4px 3px !important;     \r\n    vertical-align: middle;\r\n}\r\n\r\n:host ::ng-deep .ui-table .ui-table-frozen-view .ui-table-tbody > tr > td,\r\n.ui-table .ui-table-unfrozen-view .ui-table-tbody > tr > td {\r\n    height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-table .ui-table-tbody > tr > td {\r\n    height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-table .ui-editable-column input{\r\n    font-size: 13px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header{\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;    \r\n}\r\n.different.p-dialog .ui-widget .p-dialog-header {\r\n    display:none !important;\r\n }\r\n\r\n :host ::ng-deep .ui-button.ui-button-icon-only{\r\n    width: 1.7em !important;\r\n    height: 1.7em !important;\r\n }\r\n :host ::ng-deep body .ui-inputtext:enabled:focus:not(.ui-state-error) {\r\n    border-color: #ea1212 !important;\r\n    outline: 0 none;\r\n    -webkit-box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    box-shadow: none; }\r\n\r\n:host ::ng-deep select:disabled {   \r\n        box-shadow: none!important;\r\n        color: #858585 !important;\r\n        background-color: #FFF;\r\n        border: 1px solid #D5D5D5;\r\n    }    \r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
